// Library
import { capitalize } from 'lodash';
import { BsInfoSquare } from 'react-icons/bs';
import { FiAlertTriangle, FiXCircle } from 'react-icons/fi';
import { GoCheckCircle } from 'react-icons/go';

// CSS Style for this module
import styles from './alert.module.scss';

/**
 * Interface for Status props
 */
interface StatusProps {
	/** Status alert, error or success */
	type: 'error' | 'success' | 'info' | 'warning';
	/** Optional title to be displayed, one with the alert name is shown otherwise */
	title?: string;
	/** Text to be displayed in alert */
	msg: string;
	/** Optional line 2 for the message */
	msgLine2?: string;
	/** Optional flag to hide the default title */
	hideDefaultTitle?: boolean;
}

/**
 * Status that indicate what's the result of the user's interaction/request
 * @param {StatusProps} Prop
 * @returns  a styled block container with text
 */
export const Alert = ({ type, title, msg, msgLine2, hideDefaultTitle }: StatusProps) => {
	let icon;

	switch (type) {
		case 'error':
			icon = <FiXCircle />;
			break;
		case 'success':
			icon = <GoCheckCircle />;
			break;
		case 'info':
			icon = <BsInfoSquare />;
			break;
		case 'warning':
			icon = <FiAlertTriangle />;
			break;
	}

	return (
		<div className={[styles.alert, styles[`alert-${type}`]].join(' ')}>
			<div className={styles['alert-icon']}>{icon}</div>
			<div className={styles['alert-text']}>
				{!(!title && hideDefaultTitle) && (
					<div className={styles['alert-text-title']}>
						<p>{title ?? capitalize(type)}</p>
					</div>
				)}
				<div className={styles['alert-text-body']}>
					<p>{msg}</p>
					<p>{msgLine2}</p>
				</div>
			</div>
		</div>
	);
};
